import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MegaphoneIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M19.994 2.886L20 3l.001 5.234c1.6.544 2.499 1.662 2.499 3.266s-.9 2.722-2.499 3.266L20 18.998c0 .89-1.077 1.337-1.707.707-1.077-1.077-4.317-2.792-6.49-3.226-1.572-.315-2.514-.435-3.518-.468a20.598 20.598 0 00-.284-.007L8 18.6c0 .667.227 1.213.707 1.693a1 1 0 01-1.414 1.414C6.439 20.853 6 19.8 6 18.6v-2.651c-2.898-.31-4.5-2.023-4.5-4.949 0-3.247 1.972-5 5.5-5H7.549c.312-.002.509-.006.736-.013 1.004-.033 1.946-.153 3.519-.468 2.172-.434 5.412-2.149 6.489-3.226.602-.603 1.614-.22 1.701.593zM18 5.005c-1.687 1.065-4.004 2.116-5.804 2.476-1.674.334-2.723.468-3.845.505-.12.004-.23.007-.35.009v6.008c.12.002.23.005.35.01 1.122.036 2.171.17 3.845.504 1.8.36 4.117 1.411 5.804 2.476V5.005zM6 8.06C4.247 8.295 3.5 9.221 3.5 11s.747 2.705 2.5 2.94V8.06zm14 2.375v2.13c.352-.26.5-.606.5-1.065 0-.459-.148-.806-.5-1.065z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
MegaphoneIcon.isCarinaIcon = true;
export default MegaphoneIcon;
